function initLinks() {
	$('[data-link]').on('click', function () {
		window.location.href = $(this).data('link');
	});
}